import parseDotNetJsonDate from 'parse-dotnet-json-date'
import dateRegex from 'regex-iso-date'
import LocalDate from '@booking-services/localDate'

export default function jsonReviver (key, value) {
  if (value && typeof value == 'string') {
    if (value.match(/^\/Date\(/)) {
      return LocalDate.fromDate(parseDotNetJsonDate(value))
    }
    if (value.match(/^\d\d\d\d-\d\d-\d\d$/)) {
      return new LocalDate(value)
    }
    if (dateRegex().test(value)) {
      return new Date(value)
    }
  }
  return value
}

export function dateJSONReviver (key, value) {
  if (key.match(/date$/) && value) {
    return new LocalDate(value)
  }
  return value
}

